import * as React from 'react';

export const REFERENCE_CANVAS_WIDTH = 400;
/** Reference height for 16:9 aspect ratio at 400px width */
export const REFERENCE_CANVAS_HEIGHT = 225;

export interface CanvasSize {
    width: number;
    height: number;
    /** Offset of image within container (for object-contain letterboxing) */
    left?: number;
    top?: number;
}

const CanvasSizeContext = React.createContext<CanvasSize | null>(null);

export function useCanvasSize(): CanvasSize | null {
    return React.useContext(CanvasSizeContext);
}

/**
 * Scale factor so zones fit when either width or height is constrained.
 * Uses the minimum of width/height scale to keep zones within bounds.
 */
export function getCanvasScale(canvasSize: CanvasSize | { width: number; height: number } | null): number {
    if (!canvasSize || canvasSize.width <= 0 || canvasSize.height <= 0) return 1;
    const scaleX = canvasSize.width / REFERENCE_CANVAS_WIDTH;
    const scaleY = canvasSize.height / REFERENCE_CANVAS_HEIGHT;
    return Math.min(scaleX, scaleY);
}

export { CanvasSizeContext };
